export default {"src":"/_next/static/media/pointer.9572e396.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};